'use client';

import { Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { HighLightHorizontal } from '@/assets/icons';
import { backgrounds, dividers } from '@/assets/materials';
import HexagonalButton from '@/components/bases/HexagonalButton';

export const FeaturesSections = () => {
  const router = useRouter();

  const openAdminPage = () => {
    window.open(process.env.NEXT_PUBLIC_ADMIN_URL, '_blank');
  };

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      padding={{ xs: '32px 24px', md: '80px' }}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack gap={{ xs: 3, md: 7 }} width={'min(1280px, 100%)'} zIndex={2}>
        <Stack gap={2} width={'100%'} textAlign={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            whiteSpace={'pre-line'}
            fontSize={{ xs: '24px', md: '48px' }}
            lineHeight={{ xs: '32px', md: '68px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            {`OWN YOUR FUNDRAISING.\nSCALE WITHOUT LIMITS.`}
          </Typography>
        </Stack>
        <Stack
          alignItems={'flex-start'}
          direction={{ xs: 'column', md: 'row' }}
          gap={{ xs: 5, md: 10 }}
          justifyContent={'space-between'}>
          <Image
            priority
            src={backgrounds.browser_1}
            width={684}
            height={500}
            alt='features'
            className={'w-full md:w-[684px] h-[239px] md:h-[500px]'}
          />
          <Stack gap={{ xs: 3, md: 4.5 }}>
            <Stack gap={1}>
              <Typography component={'h5'} variant={'headLarge1'} color={'#FFFFFF'}>
                Launch Instantly
              </Typography>
              <Typography variant={'bodyLarge'} color={'#FFFFFF'} className={'mix-blend'}>
                Get inspired by successful core sales and discover new opportunities in the ecosystem.
              </Typography>
            </Stack>
            <Stack width={'100%'} alignItems={'center'} direction={'row'} gap={1}>
              <HighLightHorizontal width={'65px'} height={'10px'} color={'#FF5319'} />
              <Stack className={'w-full'} justifyContent={'center'}>
                <Image
                  src={dividers.divider_2}
                  alt={'divider'}
                  width={400}
                  height={2}
                  style={{ width: '100%', height: 'auto' }}
                />
              </Stack>
            </Stack>
            <Stack gap={1}>
              <Typography
                component={'h5'}
                variant={'headLarge1'}
                color={'#FFFFFF'}
                fontSize={{ xs: '16px', md: '24px' }}>
                Transparent & Secure
              </Typography>
              <Typography
                variant={'bodyLarge'}
                color={'#FFFFFF'}
                className={'mix-blend'}
                fontSize={{ xs: '14px', md: '18px' }}>
                Raise capital with permissionless, smart contract-driven transactions.
              </Typography>
            </Stack>
            <Stack width={'100%'} alignItems={'center'} direction={'row'} gap={1}>
              <HighLightHorizontal width={'65px'} height={'10px'} color={'#91FF68'} />
              <Stack className={'w-full'} justifyContent={'center'}>
                <Image
                  src={dividers.divider_2}
                  alt={'divider'}
                  width={400}
                  height={2}
                  style={{ width: '100%', height: 'auto' }}
                />
              </Stack>
            </Stack>
            <Stack gap={1}>
              <Typography
                component={'h5'}
                variant={'headLarge1'}
                color={'#FFFFFF'}
                fontSize={{ xs: '16px', md: '24px' }}>
                Build for the Future
              </Typography>
              <Typography
                variant={'bodyLarge'}
                color={'#FFFFFF'}
                className={'mix-blend'}
                fontSize={{ xs: '14px', md: '18px' }}>
                Engage your community, scale your ecosystem, and drive sustainable growth.
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack alignItems={'center'} direction={{ xs: 'column', md: 'row' }} gap={2} justifyContent={'center'}>
          <Stack width={284} display={{ xs: 'none', md: 'block' }}>
            <HexagonalButton variant={'danger'} label={'LAUNCH YOURS TODAY'} onClick={openAdminPage} />
          </Stack>
          <Stack width={209} display={{ xs: 'block', md: 'none' }}>
            <HexagonalButton variant={'danger'} label={'LAUNCH YOURS TODAY'} size={'small'} onClick={openAdminPage} />
          </Stack>
          <Stack width={319} display={{ xs: 'none', md: 'block' }}>
            <HexagonalButton
              variant={'secondary'}
              label={'EXPLORE LIVE CORE SALES'}
              onClick={() => router.push('/explore')}
            />
          </Stack>
          <Stack width={235} display={{ xs: 'block', md: 'none' }}>
            <HexagonalButton
              variant={'secondary'}
              label={'EXPLORE LIVE CORE SALES'}
              size={'small'}
              onClick={() => router.push('/explore')}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
